import React, { Fragment } from 'react';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';

import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import WarningIcon from '@mui/icons-material/Warning';

import Dropzone from '../../../../../shared/dropzone/Dropzone';
import Input from '../../../../../shared/Input';

import { procedureFlows, cmfExtendedProcedureFlows } from '../../../../../../constants/cases';
import userRoles from '../../../../../../constants/userRoles';

const isWeekend = (date) => {
  const day = date.day();

  return day === 0 || day === 6;
};

export const CmfStep1 = ({
  activeCase,
  fileStatuses,
  rejectedFiles,
  date,
  setDate,
  xRays,
  handleXRaysUpload,
  handleRemoveXRay,
  onUploadXRayComplete,
  scans,
  handleScansUpload,
  handleRemoveScan,
  onUploadScanComplete,
  mris,
  handleMriUpload,
  handleRemoveMri,
  onUploadMriComplete,
  reports,
  handleReportUpload,
  handleRemoveReport,
  onUploadReportComplete,
  userRole,
  requestPlanning,
  setRequestPlanning,
  requestPlanningDate,
  setRequestPlanningDate,
  additionalEmails,
  setAdditionalEmails
}) => (
  <LocalizationProvider dateAdapter={AdapterMoment}>
    <Fragment>
      {activeCase.files && activeCase.files.some((file) => file.status === fileStatuses.REJECTED) && (
        <div className="alert warning">
          <div className="d-flex align-center">
            <WarningIcon color="primary" />
            <div>
              {`Some of the scans have been rejected: 
                      ${rejectedFiles.map((file, index) => `${file.name} `)}`}
            </div>
          </div>
          {activeCase.notes && activeCase.notes.step2 && <div className="m-t-md">Note: {activeCase.notes.step2}</div>}
        </div>
      )}

      {userRole !== userRoles.RADIOLOGY.name && (
        <div className="field-container m-t-lg">
          <div className="secondary font-size-sm uppercase">Targeted surgery date</div>
          <DatePicker
            desktopModeMediaQuery="(min-width: 0px)"
            value={date}
            onChange={setDate}
            disabled={userRole === userRoles.RADIOLOGY.name}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                variant: 'standard',
              },
            }}
          />
        </div>
      )}

      <div className="modal-item-block">
        <div className="block-header">
          UPLOAD CT/CBCT DICOM*
        </div>
        <Dropzone
          type="archive"
          files={scans}
          onUpload={handleScansUpload}
          onRemove={handleRemoveScan}
          icon="scan"
          withProgress
          path={`${activeCase.id}/${activeCase.id}`}
          suffix="scan"
          onUploadComplete={onUploadScanComplete}
        />
      </div>
      {activeCase.procedureFlow === procedureFlows.CMF && (
        <div className="modal-item-block">
          <div className="block-header">
            UPLOAD DENTAL MODELS
          </div>
          <Dropzone
            type='archive'
            files={mris}
            onUpload={handleMriUpload}
            onRemove={handleRemoveMri}
            icon="x-ray"
            withProgress
            path={`${activeCase.id}/${activeCase.id}`}
            suffix="mri"
            onUploadComplete={onUploadMriComplete}
          />
        </div>
      )}
      <div className="modal-item-block">
        <div className="block-header">UPLOAD ADDITIONAL FILES</div>
        <Dropzone
          files={xRays}
          onUpload={handleXRaysUpload}
          onRemove={handleRemoveXRay}
          icon="x-ray"
          withProgress
          path={`${activeCase.id}/${activeCase.id}`}
          suffix="x-ray"
          onUploadComplete={onUploadXRayComplete}
        />
      </div>
      {/*{userRole !== userRoles.RADIOLOGY.name && (*/}
      {/*  <div className="modal-item-block">*/}
      {/*    <div className="block-header">Surgeon consultation report</div>*/}
      {/*    <Dropzone*/}
      {/*      files={reports}*/}
      {/*      onUpload={handleReportUpload}*/}
      {/*      onRemove={handleRemoveReport}*/}
      {/*      icon="scan"*/}
      {/*      withProgress*/}
      {/*      path={`${activeCase.id}/${activeCase.id}`}*/}
      {/*      suffix="report"*/}
      {/*      onUploadComplete={onUploadReportComplete}*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*)}*/}

      {cmfExtendedProcedureFlows.includes(activeCase.procedureFlow) && userRole !== userRoles.RADIOLOGY.name && (
        <div>
          <div className='d-flex space-between'>
            <div className='secondary uppercase font-bold font-size-sm'>Request planning meeting</div>
            <div className="radio-group-container">
              <RadioGroup row aria-label="requestPlanning" name="requestPlanning" value={requestPlanning} onChange={(e) => setRequestPlanning(e.target.value === 'true')}>
                <FormControlLabel value={true} control={<Radio color="primary" />} label="Yes" />
                <FormControlLabel value={false} control={<Radio color="primary" />} label="No" />
              </RadioGroup>
            </div>
          </div>
          {requestPlanning && (
            <>
              <div style={{ width: '50%' }}>
                <DateTimePicker
                  desktopModeMediaQuery="(min-width: 0px)"
                  label="Planning meeting"
                  value={requestPlanningDate}
                  onChange={setRequestPlanningDate}
                  shouldDisableDate={isWeekend}
                  disablePast
                  format="DD/MM/YYYY HH:mm"
                  slotProps={{
                    textField: { variant: 'standard' },
                  }}
                />
              </div>
              <div className='m-t-lg'>
                <div className="secondary uppercase font-size-xs">Additional attendees (email addresses)</div>
                <div className='w-100 m-t-sm'>
                  <Input
                    id="additionalEmails"
                    type="text"
                    value={additionalEmails}
                    onChange={(e) => setAdditionalEmails(e.target.value)}
                    fullWidth
                  />
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </Fragment>
  </LocalizationProvider>
);
